import { useFormatLocalizedNumber } from '@pba/react-utils';
import { useCallback, useMemo } from 'react';

export const useFormatValue = () => {
  const formatLocalizedNumber = useFormatLocalizedNumber();

  const formatter = useCallback(
    (value?: number | string): string =>
      // Parser below removes comma as thousands separator, so locale must stay en-US.
      formatLocalizedNumber({ localeCode: 'en-US', value }),
    [formatLocalizedNumber],
  );

  const parser = useCallback((value: string | undefined): number => Number(value?.split(',').join('') ?? 0), []);

  return useMemo(() => ({ formatter, parser }), [formatter, parser]);
};
